// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commuting {
  background: #f3f4f6;
}
.commuting__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.commuting__buttons {
  margin-top: 24px;
  display: flex;
}
.commuting__buttons__calendar {
  margin-right: 10px;
}
.commuting__buttons__dropdown {
  width: 150px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.commuting__buttons__inquiry {
  margin-left: 10px;
}
.commuting__buttons__pdf {
  margin-left: auto;
}
.commuting__buttons__excel {
  margin-left: 10px;
}
.commuting__buttons__schedule {
  margin-left: 10px;
}
.commuting__text {
  margin-top: 12px;
  margin-bottom: 24px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.commuting__table-card {
  background: #ffffff;
  padding: 2%;
  border-radius: 16px;
}
.commuting__table-scrollable::-webkit-scrollbar {
  display: block;
}
.commuting__table-sticky {
  border-collapse: collapse;
  white-space: nowrap;
  border-style: hidden;
  border-radius: 6px 0px 0px 6px !important;
  box-shadow: 4px 0 5px -2px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9e9e9;
}
.commuting__table-scrollable {
  display: block;
  overflow-y: auto;
  white-space: nowrap;
  border-collapse: collapse;
  border-radius: 0px 6px 6px 0px;
}
.commuting__table {
  display: flex;
}
.commuting__table__popup {
  border: 1px solid #e9e9e9 !important;
  box-shadow: 6px 6px 18px rgba(0, 0, 0, 0.1) !important;
  border-radius: 12px !important;
  font-family: "Spoqa Han Sans Neo" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 22px !important;
  color: #868686 !important;
}
.commuting__table__th {
  height: 62px;
  padding: 20px;
  border-top: 1px solid #e9e9e9;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #505054;
}
.commuting__table__td {
  text-align: center;
  border-bottom: 1px solid #e9e9e9;
  height: 60px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  color: #566370;
}
.commuting__table__td-left {
  text-align: center;
  border-bottom: 1px solid #e9e9e9;
  border-left: 1px solid #e9e9e9;
  height: 60px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  color: #566370;
}
.commuting__table__icon {
  margin-left: 5px;
  position: relative;
  top: 20%;
  transform: translateY(-50%);
}
.commuting__footer-text {
  margin-top: 24px;
}
.commuting__footer-text__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
  padding-bottom: 6px;
}
.commuting__footer-text__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}

.gridArea {
  margin-top: 30px;
  position: relative;
}

div {
  font-family: "DejaVu Sans", "Arial", sans-serif;
}

@font-face {
  font-family: "DejaVu Sans";
  src: url("https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans.ttf") format("truetype");
}
@font-face {
  font-family: "DejaVu Sans";
  font-weight: bold;
  src: url("https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "DejaVu Sans";
  font-style: italic;
  src: url("https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
}
@font-face {
  font-family: "DejaVu Sans";
  font-weight: bold;
  font-style: italic;
  src: url("https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
}`, "",{"version":3,"sources":["webpack://./src/screens/commuting/commuting.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AACI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACR;AAEI;EACI,gBAAA;EACA,aAAA;AAAR;AAEQ;EACI,kBAAA;AAAZ;AAGQ;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAFZ;AAKQ;EACI,iBAAA;AAHZ;AAMQ;EACI,iBAAA;AAJZ;AAOQ;EACI,iBAAA;AALZ;AAQQ;EACI,iBAAA;AANZ;AAUI;EACI,gBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARR;AAWI;EACI,mBAAA;EACA,WAAA;EACA,mBAAA;AATR;AAYI;EACI,cAAA;AAVR;AAaI;EACI,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yCAAA;EACA,6CAAA;EACA,yBAAA;AAXR;AAcI;EACI,cAAA;EACA,gBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAbR;AAgBI;EACI,aAAA;AAdR;AAgBQ;EACI,oCAAA;EACA,sDAAA;EACA,8BAAA;EAEA,4CAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;AAfZ;AAkBQ;EACI,YAAA;EACA,aAAA;EACA,6BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAhBZ;AAmBQ;EACI,kBAAA;EACA,gCAAA;EACA,YAAA;EAEA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAlBZ;AAqBQ;EACI,kBAAA;EACA,gCAAA;EACA,8BAAA;EACA,YAAA;EAEA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AApBZ;AAuBQ;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AArBZ;AAyBI;EACI,gBAAA;AAvBR;AAyBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAvBZ;AA0BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBZ;;AA6BA;EACI,gBAAA;EACA,kBAAA;AA1BJ;;AA6BA;EACI,+CAAA;AA1BJ;;AA6BA;EACI,0BAAA;EACA,0GAAA;AA1BJ;AA6BA;EACI,0BAAA;EACA,iBAAA;EACA,+GAAA;AA3BJ;AA8BA;EACI,0BAAA;EACA,kBAAA;EACA,kHAAA;AA5BJ;AA+BA;EACI,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kHAAA;AA7BJ","sourcesContent":[".commuting {\n    background: #f3f4f6;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 38px;\n        color: #333333;\n    }\n\n    &__buttons {\n        margin-top: 24px;\n        display: flex;\n\n        &__calendar {\n            margin-right: 10px;\n        }\n\n        &__dropdown {\n            width: 150px;\n            height: 40px;\n            background: #ffffff;\n            border: 1px solid #e9e9e9;\n            border-radius: 8px 0px 0px 8px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n        }\n\n        &__inquiry {\n            margin-left: 10px;\n        }\n\n        &__pdf {\n            margin-left: auto;\n        }\n\n        &__excel {\n            margin-left: 10px;\n        }\n\n        &__schedule {\n            margin-left: 10px;\n        }\n    }\n\n    &__text {\n        margin-top: 12px;\n        margin-bottom: 24px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n    }\n\n    &__table-card {\n        background: #ffffff;\n        padding: 2%;\n        border-radius: 16px;\n    }\n\n    &__table-scrollable::-webkit-scrollbar {\n        display: block;\n    }\n\n    &__table-sticky {\n        border-collapse: collapse;\n        white-space: nowrap;\n        border-style: hidden;\n        border-radius: 6px 0px 0px 6px !important ;\n        box-shadow: 4px 0 5px -2px rgba(0, 0, 0, 0.1);\n        border: 1px solid #e9e9e9;\n    }\n\n    &__table-scrollable {\n        display: block;\n        overflow-y: auto;\n        // scrollbar-width: none;\n        white-space: nowrap;\n        border-collapse: collapse;\n        border-radius: 0px 6px 6px 0px;\n    }\n\n    &__table {\n        display: flex;\n\n        &__popup {\n            border: 1px solid #e9e9e9 !important;\n            box-shadow: 6px 6px 18px rgba(0, 0, 0, 0.1) !important;\n            border-radius: 12px !important;\n\n            font-family: 'Spoqa Han Sans Neo' !important;\n            font-style: normal !important;\n            font-weight: 400 !important;\n            font-size: 14px !important;\n            line-height: 22px !important;\n            color: #868686 !important;\n        }\n\n        &__th {\n            height: 62px;\n            padding: 20px;\n            border-top: 1px solid #e9e9e9;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            text-align: center;\n            color: #505054;\n        }\n\n        &__td {\n            text-align: center;\n            border-bottom: 1px solid #e9e9e9;\n            height: 60px;\n\n            font-family: 'Noto Sans KR';\n            font-style: normal;\n            font-weight: 500;\n            color: #566370;\n        }\n\n        &__td-left {\n            text-align: center;\n            border-bottom: 1px solid #e9e9e9;\n            border-left: 1px solid #e9e9e9;\n            height: 60px;\n\n            font-family: 'Noto Sans KR';\n            font-style: normal;\n            font-weight: 500;\n            color: #566370;\n        }\n\n        &__icon {\n            margin-left: 5px;\n            position: relative;\n            top: 20%;\n            transform: translateY(-50%);\n        }\n    }\n\n    &__footer-text {\n        margin-top: 24px;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 18px;\n            color: #505054;\n            padding-bottom: 6px;\n        }\n\n        &__body {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            color: #999999;\n        }\n    }\n}\n\n.gridArea {\n    margin-top: 30px;\n    position: relative;\n}\n\ndiv {\n    font-family: \"DejaVu Sans\", \"Arial\", sans-serif;\n}\n\n@font-face {\n    font-family: \"DejaVu Sans\";\n    src: url(\"https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"DejaVu Sans\";\n    font-weight: bold;\n    src: url(\"https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans-Bold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"DejaVu Sans\";\n    font-style: italic;\n    src: url(\"https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"DejaVu Sans\";\n    font-weight: bold;\n    font-style: italic;\n    src: url(\"https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
